import React from "react";
import { Container, Grid2 } from "@mui/material";
import { motion } from "motion/react";
import "./home.css";
import active from "./assets/active.png";
import consult from "./assets/consult.png";
import effortless from "./assets/effortless.png";
import find from "./assets/find.png";
import register from "./assets/register.png";
import schedule from "./assets/schedule.png";
import secure from "./assets/secure.png";
import verified from "./assets/verified.png";
import ai from "./assets/ai.png";
import bookLawyer from "./assets/bookLawyer.png";
import video from "./assets/video.png";
import assistant from "./assets/assistant.png";
import hero from "./assets/hero.png";
import FAQ from "../components/faq";
import Footer from "../components/footer";
import TitleDiv from "../components/titlediv";
import heroPic from "./assets/heroPic.png";
import HomeHeader from "./new/components/homeHeader";

function LandingPage() {
  return (
    <div className="App">
      <HomeHeader
        isTitle={false}
        title={""}
        headerColor="header-white"
        navItems={true}
      />
      {/* Hero Section */}
      <motion.div
        className="hero-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-content">
          <motion.p
            className="hero-heading"
            initial={{ y: -50 }}
            whileInView={{ y: 0 }}
            transition={{ type: "spring", stiffness: 100 }}
          >
            Find the Best Lawyers, Anytime, Anywhere
          </motion.p>
          <motion.p
            variant="body2"
            className="hero-subtitle"
            initial={{ y: 50 }}
            whileInView={{ y: 0 }}
            transition={{ type: "spring", stiffness: 100 }}
          >
            Harness the Power of AI for Quick, Reliable Access to Top Legal
            Experts — No Matter Where You Are, Get the Legal Help You Need in
            Minutes.
          </motion.p>
          <button className="get-started-button">
            <p className="get-started-button-text">Get Started</p>
          </button>
        </div>
        <motion.div
          className="hero-image-home"
          style={{ zIndex: 1 }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <img src={heroPic} alt="Lawyer Illustration" />
        </motion.div>
      </motion.div>

      {/* Features Section */}
      <motion.div
        className="features-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <TitleDiv text="HOW IT WORKS" />
        <motion.p
          className="section-title"
          initial={{ x: -100 }}
          whileInView={{ x: 0 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          An AI-Enhanced Process For <br /> Clients And Lawyers
        </motion.p>
        <motion.p
          className="section-description"
          initial={{ x: 100 }}
          whileInView={{ x: 0 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          Leverage AI to quickly get legal insights, match with expert lawyers,
          and <br /> book your consultation — all powered by intelligent
          technology.
        </motion.p>
        <Grid2
          style={{ padding: "120px 0", margin: "0 10%" }}
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          wrap="wrap"
        >
          {[
            {
              title: "Register & Set Up",
              image: register,
              description:
                "Get started by creating a profile with just a few details to access personalized legal services.",
            },
            {
              title: "Get AI Legal Advice",
              image: ai,
              description:
                "Receive instant, AI-driven legal guidance tailored to your needs, helping you understand your situation.",
            },
            {
              title: "Book a Lawyer",
              image: bookLawyer,
              description:
                "Browse through expert lawyers matched to your case and schedule a consultation at a time that suits you.",
            },
            {
              title: "Meet Via Video",
              image: video,
              description:
                "Join a secure video consultation with your chosen lawyer to get professional legal advice and discuss your case.",
            },
          ].map((feature, index) => (
            <Grid2 item xs={15} md={3} key={index} className="feature-box">
              <motion.img
                src={feature.image}
                alt={feature.title}
                className="responsive-icon"
                initial={{ y: 50 }}
                whileInView={{ y: 0 }}
                transition={{ type: "spring", stiffness: 120 }}
              />
              <motion.p
                className="feature-title"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.2, duration: 1 }}
              >
                {feature.title}
              </motion.p>
              <motion.p
                variant="body2"
                className="feature-description"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 1 }}
              >
                {feature.description}
              </motion.p>
            </Grid2>
          ))}
        </Grid2>
      </motion.div>

      {/* Key Features */}
      <motion.div
        className="key-features-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <TitleDiv text="KEY FEATURES" />

        <motion.p
          className="section-title"
          initial={{ x: -100 }}
          whileInView={{ x: 0 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          Powerful Features For <br /> Effortless Legal Consultations
        </motion.p>

        <motion.p
          className="section-description"
          initial={{ x: 100 }}
          whileInView={{ x: 0 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          Our platform leverages AI-powered tools to make legal assistance
          faster and simpler, offering intuitive <br /> solutions to connect
          with experts and manage your consultations seamlessly.
        </motion.p>

        <Grid2
          container
          spacing={12}
          justifyContent="center"
          alignItems="flex-start"
        >
          {[
            {
              title: "AI Assistant",
              image: assistant,
              description:
                "Get tailored guidance with our AI assistants that help connect you with the most suitable lawyers for your needs, simplifying your search for the right legal expertise.",
            },
            {
              title: "Active Community Engagement",
              image: active,
              description:
                "Join a vibrant community where users ask questions, and lawyers share insights by answering posts or contributing helpful articles to increase their visibility.",
            },
            {
              title: "Secure Video Consultations",
              image: secure,
              description:
                "Connect with trusted lawyers through private, secure video calls, offering 30-minute or 1-hour consultations from the comfort of your home.",
            },
            {
              title: "Effortless Scheduling",
              image: effortless,
              description:
                "Easily select a convenient time for your consultation, with flexible options to book, reschedule, or cancel appointments.",
            },
          ].map((feature, index) => (
            <Grid2
              item
              xs={6}
              sm={6}
              md={6}
              lg={6}
              key={index}
              className="key-feature-box"
            >
              <motion.img
                src={feature.image}
                alt={feature.title}
                className="responsive-img"
                initial={{ y: 50 }}
                whileInView={{ y: 0 }}
                transition={{ type: "spring", stiffness: 120 }}
              />
              <motion.p
                className="key-feature-title"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.2, duration: 1 }}
              >
                {feature.title}
              </motion.p>
              <motion.p
                className="key-feature-description"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ delay: 0.3, duration: 1 }}
              >
                {feature.description}
              </motion.p>
            </Grid2>
          ))}
        </Grid2>
      </motion.div>

      {/* Solutions Section */}
      <motion.div
        className="solutions-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <motion.p
          className="solutions-title"
          initial={{ y: 50 }}
          whileInView={{ y: 0 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          Unlock Your Legal Solutions With AI
        </motion.p>
        <motion.p
          className="solutions-description"
          initial={{ y: 50 }}
          whileInView={{ y: 0 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          Whether you're seeking expert legal advice or offering your services
          as a lawyer, our AI-powered platform simplifies the process for both
          clients and legal professionals. Get started today and experience
          seamless consultations and legal support.
        </motion.p>
        <div className="solutions-buttons">
          <button className="solution-button">
            <p className="solution-button-text">Find a Lawyer</p>
          </button>
          <button className="solution-button">
            <p className="solution-button-text">Sign Up</p>
          </button>
        </div>
      </motion.div>

      {/* Additional Sections */}
      <FAQ />
      <Footer />
    </div>
  );
}

export default LandingPage;
